import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'irembogov-fb-inline-edit',
  templateUrl: './fb-inline-edit.component.html',
  styleUrls: ['./fb-inline-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FbInlineEditComponent {
  @Input() value = '';
  @Input() placeholder = 'Click to edit';
  @Input() tag: 'h6' | 'span' = 'span';
  @Output() valueChange = new EventEmitter<string>();
  @ViewChild('inputRef') inputRef!: ElementRef<HTMLInputElement>;

  editing = false;
  editValue = '';

  startEdit(): void {
    this.editing = true;
    this.editValue = this.value;
    setTimeout(() => this.inputRef?.nativeElement?.focus(), 0);
  }

  confirmEdit(): void {
    this.editing = false;
    if (this.editValue.trim() && this.editValue !== this.value) {
      this.valueChange.emit(this.editValue.trim());
    }
  }

  cancelEdit(): void {
    this.editing = false;
    this.editValue = this.value;
  }

  onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.confirmEdit();
    } else if (event.key === 'Escape') {
      this.cancelEdit();
    }
  }
}
